"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; } // +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.A2.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed A2并不是自由软件，未经许可不能去掉A2相关版权
// +----------------------------------------------------------------------
// | Author: A2 Team <admin@A2.com>
// +----------------------------------------------------------------------
var storeRouter = {
  path: '/leaseProduct',
  component: _layout.default,
  redirect: '/leaseProduct/index',
  name: 'LeaseProductStore',
  meta: {
    title: '租赁商品',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/leaseStore/index'));
      });
    },
    name: 'LeaseProductList',
    meta: {
      title: '租赁商品管理',
      icon: ''
    }
  }, {
    path: 'list/creatProduct/:tabIndex?/:id?/:isDisabled?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/leaseStore/creatStore/index'));
      });
    },
    name: 'LeaseProductProductAdd',
    meta: {
      title: '租赁商品添加',
      noCache: true,
      activeMenu: "/leaseProduct/index"
    },
    hidden: true
  }, {
    path: 'list/productDetail/:tabIndex?/:id?/:isDisabled?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/coreProduct/coreCreatStore/detail'));
      });
    },
    name: 'LeaseProductDetail',
    meta: {
      title: '商品详情',
      noCache: true,
      activeMenu: "/leaseProduct/index"
    },
    hidden: true
  }, {
    path: 'list/inventoryAdjust/:tabIndex?/:id?/:isDisabled?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/leaseStore/inventoryAdjust/index'));
      });
    },
    name: 'LeaseProductInventoryAdjust',
    meta: {
      title: '库存调整',
      noCache: true,
      activeMenu: "/leaseProduct/index"
    },
    hidden: true
  }, {
    path: 'config',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/leaseStore/config/index'));
      });
    },
    name: 'LeaseProductConfig',
    meta: {
      title: '租赁商品添加',
      noCache: true,
      activeMenu: "/leaseProduct/index"
    },
    hidden: true
  }]
};
var _default = exports.default = storeRouter;